import { render, staticRenderFns } from "./CardSpa.vue?vue&type=template&id=24514e5d&"
import script from "./CardSpa.vue?vue&type=script&lang=js&"
export * from "./CardSpa.vue?vue&type=script&lang=js&"
import style0 from "./CardSpa.vue?vue&type=style&index=0&id=24514e5d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports